import { createStore } from 'vuex'
import filter from '@/store/filter'
import product from '@/store/product'

export default createStore({
  state: {
    initialized: false
  },
  getters: {
  },
  mutations: {
    setInitialized (state, payload) {
      state.initialized = payload
    }
  },
  actions: {
    init ({ dispatch, commit }) {
      Promise.all([
        dispatch('filter/initFilter'),
        dispatch('product/get')
      ]).then(() => {
        commit('setInitialized', true)
      })
    },
    loadNextPage ({ commit, dispatch }) {
      commit('product/increaseCurrentPage')
      Promise.all([
        dispatch('product/get')
      ])
    },
    loadPageBefore ({ commit, dispatch }) {
      commit('product/decreaseCurrentPage')
      Promise.all([
        dispatch('product/get')
      ])
    },
    loadPage ({ commit, dispatch }, number) {
      commit('product/setCurrentPage', number)
      Promise.all([
        dispatch('product/get')
      ])
    },
    updateItemsPerPage ({ commit }, number) {
      commit('product/setItemsPerPage', number)
    },
    pushState ({ state }) {
      const url = new URL(window.location.href)
      url.searchParams.delete('filters')
      url.searchParams.delete('sortingAsc')
      url.searchParams.delete('sortingDsc')
      url.searchParams.delete('sortingRelevance')
      if (state.filter.sortingAsc) {
        url.searchParams.set('sortingAsc', state.filter.sortingAsc)
      }
      if (state.filter.sortingDsc) {
        url.searchParams.set('sortingDsc', state.filter.sortingDsc)
      }
      if (state.filter.sortingRelevance) {
        url.searchParams.set('sortingRelevance', state.filter.sortingRelevance)
      }
      if (state.filter.filterCategories.length > 0) {
        url.searchParams.set('filters', JSON.stringify(state.filter.filterCategories))
      }
      window.history.pushState({}, '', url)
    },
    filterProducts ({ dispatch }) {
      dispatch('pushState')
      Promise.all([
        dispatch('product/get')
      ])
    }
  },
  modules: {
    product: product,
    filter: filter
  }
})
